import { normalizeCurrencyValue } from './normalizeCurrencyValue';

export interface CalculateIncomesParams {
    grossMonthlyIncome?: number | string | null;
    annualIncome?: number | string | null;
}

export interface CalculatedIncomes {
    grossMonthlyIncome: number;
    annualIncome: number;
}

const roundToTwoDecimals = (value: number): number => Math.round(value * 100) / 100;

export const calculateIncomes = ({
    grossMonthlyIncome,
    annualIncome,
}: CalculateIncomesParams): CalculatedIncomes => {
    const normalizedGrossMonthlyIncome = normalizeCurrencyValue(grossMonthlyIncome);
    const normalizedAnnualIncome = normalizeCurrencyValue(annualIncome);

    const finalAnnualIncome = normalizedAnnualIncome ?? (normalizedGrossMonthlyIncome ?? 0) * 12;

    const finalGrossMonthlyIncome =
        normalizedGrossMonthlyIncome ?? roundToTwoDecimals((normalizedAnnualIncome ?? 0) / 12);

    return {
        grossMonthlyIncome: finalGrossMonthlyIncome,
        annualIncome: finalAnnualIncome,
    };
};
